module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": _vm.url,
      "httpOptions": _vm.options,
      "fields": _vm.fields
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-545f840d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatusTable.vue
// module id = 240
// module chunks = 1